import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as ClockIcon } from "../../../../assets/icons/clock.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";
import PunchInoutStyles from "./PunchInout.styles";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks";
import { punchOutAction, punchInAction, selectPunchInTime, selectPunchInUserId } from "../../../../redux/userDataSlice";
import { useEffect, useState } from "react";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import { selectUserId } from "../../../../redux/authSlice";
import { checkPunchIn, punchIn, punchOut } from "./PunchService";
import { isTruthy, openErrorNotification, openSuccessNotification } from "../../../../helpers/methods";
import notifiers from "../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../utils/customErrorHandler";
import { Box, Typography } from "@mui/material";
import moment from "moment";

const PunchInOut = () => {
  const classes = PunchInoutStyles;
  const [isDialogBox, setIsDialogBox] = useState(false);
  const [punchInOutInfo, setPunchInOutInfo] = useState<any>({
    month: "",
    date: "",
    punch_in: "",
    punch_out: "",
    working_hours: "",
  });
  const [checkpunchInOutInfo, setcheckPunchInOutInfo] = useState<any>({
    punch_out: "",
  });

  const punchInIdFromRedux = useAppSelector(selectPunchInUserId);
  const userIdFromRedux = useAppSelector(selectUserId);
  const punchInTimeFromRedux = useAppSelector(selectPunchInTime);
  const currentTime = moment().format("h:mm");
  const currentDayDateYear = moment().format("ddd D MMM, YYYY");
  const amPmIndicator = moment().format("A");
  const dispatch = useAppDispatch();

  useEffect(() => {
    initFunction();
  }, []);

  const initFunction = async () => {
  
    try {
      const response = await checkPunchIn(userIdFromRedux);
    //  customErrorHandler(response);
      
      const {punch_out,month,date,punch_in,_id } = response.data;
      
      setcheckPunchInOutInfo({punch_out});
      setPunchInOutInfo({ ...punchInOutInfo, punch_out,  month, date, punch_In: punch_in })
      dispatch(
        punchInAction({
          punchInIdUserId: _id,
          punchIin: punch_in,
        })
      );
      setIsDialogBox(false);
    } catch (error: any) {
      // openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
    }
  };
  // API call Function
  const clockInCall = async (actionType: string) => {
    if (actionType === "open") {
      setIsDialogBox(true);
      return;
    }
    try {
      const response = await punchIn(userIdFromRedux);
      !(response.data.punch_out == "00:00") && customErrorHandler(response);
      
      const { month, date, punch_in, _id,punch_out } = response.data;

      setPunchInOutInfo({ ...punchInOutInfo, punch_out,  month, date, punch_In: punch_in });
      dispatch(
        punchInAction({
          punchInIdUserId: _id,
          punchIin: punch_in,
        })
        
        );
        initFunction();
     
      (response.message == 1) && openSuccessNotification(response.message);
      setIsDialogBox(false);
    } catch (error: any) {
      openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
    }
  };
 

  const punchOutCall = async (actionType: string) => {
    if (actionType === "open") {
      setIsDialogBox(true);
      return;
    }
    try {
      const response = await punchOut(userIdFromRedux, punchInIdFromRedux, punchInTimeFromRedux);
      customErrorHandler(response);
      const { month, date, punch_in, punch_out, working_hours } = response.data;
      setPunchInOutInfo({
        ...punchInOutInfo,
        month,
        date,
        punch_in,
        punch_out,
        working_hours: working_hours,
      });
      dispatch(punchOutAction());
      openSuccessNotification(response.message);
      setIsDialogBox(false);
    initFunction();

    } catch (error: any) {
      openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
    }
  };

  const dialogHeaderContent = () => {
    return (
      <>
        <Box sx={classes.contentWrapper}>
          <CloseIcon onClick={() => setIsDialogBox(false)} style={{ position: "absolute", right: "18px", top: "8px", cursor: "pointer" }} />
          <Box>
            <Typography sx={classes.cardTitle}>Your Clock In Time</Typography>
            <Typography sx={classes.subTitle}>Please Confirm your Clock-in Time</Typography>
          </Box>
          <Box sx={classes.timeCard}>
            <Typography sx={classes.currTime}>
              {currentTime}
              <span>{amPmIndicator}</span>
            </Typography>
            <Typography classes={classes.currDate}>{currentDayDateYear}</Typography>
          </Box>
        </Box>
      </>
    );
  };

  // JSX return Function
  const getClockInOut = (actionType = "") => {
    return (
      <Box sx={classes.buttons}>
        { checkpunchInOutInfo.punch_out == "00:00" ? (
          <CustomButton label='Clock Out' onClick={() => punchOutCall(actionType)} startIcon={<ClockIcon />} customClasses={classes.clockOut} />
        ) : (
          <CustomButton label='Clock In' onClick={() => clockInCall(actionType)} startIcon={<ClockIcon />} customClasses={classes.clockIn} />
        )}
      </Box>
    );
  };

  return (
    <>
      {/* {getClockInOut("open")} */}
      <CustomDialog isDialogOpen={isDialogBox} dialogHeaderContent={dialogHeaderContent()} dialogTitleContent={getClockInOut()} handleDialogClose={() => setIsDialogBox(false)} />
    </>
  );
};

export default PunchInOut;
